import { Car, Bath, Waves, Accessibility, PawPrint } from "lucide-react";

const FilterChips = ({ filters, onChange }) => {
  const filterOptions = [
    { key: "has_parking", icon: Car, label: "Parking", activeColor: "bg-blue-500" },
    { key: "has_bathrooms", icon: Bath, label: "Restrooms", activeColor: "bg-orange-500" },
    { key: "has_showers", icon: Waves, label: "Showers", activeColor: "bg-green-500" },
    { key: "is_accessible", icon: Accessibility, label: "Accessible", activeColor: "bg-purple-500" },
    { key: "is_pet_friendly", icon: PawPrint, label: "Pets OK", activeColor: "bg-amber-500" },
  ];

  const toggleFilter = (key) => {
    onChange({
      ...filters,
      [key]: filters[key] ? undefined : true,
    });
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid="filter-chips">
      {filterOptions.map((option) => (
        <button
          key={option.key}
          onClick={() => toggleFilter(option.key)}
          data-testid={`filter-${option.key}`}
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold border-2 transition-all duration-200 ${
            filters[option.key]
              ? `${option.activeColor} text-white border-transparent shadow-md`
              : "bg-white text-gray-700 border-gray-200 hover:border-[#0EA5E9] hover:text-[#0EA5E9]"
          }`}
        >
          <option.icon className="w-4 h-4" />
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default FilterChips;
